import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { PageWrapper, PageWrapperProps } from "./PageWrapper";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const pageDetails: PageWrapperProps = {
  className: "ErrorPage",
  headerText: "Error"
};

export const ErrorPage = () => {
  const { t } = useTranslation();
  const error = useRouteError();
  console.error(error);
  let errorMessage: string;

  if (isRouteErrorResponse(error)) {
    errorMessage = error.data.message || error.statusText;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === "string") {
    errorMessage = error;
  } else {
    errorMessage = "Unknown error";
  }

  return (
    <PageWrapper {...pageDetails}>
      <Typography>{t("An unexpected error has occured.")}</Typography>
      <Typography sx={{ fontStyle: "italic" }}>{errorMessage}</Typography>
    </PageWrapper>
  );
};
